import * as React from 'react';

const ActionSelectorIcon = ({fillColor = '#2D2756'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={12} height={14}>
    <path
      fill={fillColor}
      fillRule="evenodd"
      d="m4.398 9.95-3.09 3.735c-.207.29-.476.38-.809.269-.333-.112-.499-.347-.499-.705V.742C0 .435.137.215.41.084a.715.715 0 0 1 .78.07l9.885 7.763c.273.23.35.507.23.831-.12.324-.35.487-.692.487L5.702 9.2h-.607l-.697.75Zm-.492-1.863-2.758 3.87V1.595l8.263 6.492H3.906Z"
      clipRule="evenodd"
    />
  </svg>
);

export default ActionSelectorIcon;
